import React from "react";
import styled from "styled-components";

import type { MetricWithObject } from "types/BusinessDashboard";
import {
  REFUND_CANCEL_META,
  formatRefundCancelWon,
} from "constants/salesServiceType";

import { SalesChangeIndicator } from "./sales-change-indicator";

/**
 * 환불·취소 줄.
 *
 * 분류가 아니므로 분류 목록·도넛 조각에 넣지 않고 구분선 아래 별도 줄로 둔다.
 * 서버는 양수 크기로 내려주므로 음수 부호는 여기서 붙인다.
 * 증감률은 환불 규모 기준이라 환불이 늘면 `+`로 나오므로 중립 표기를 쓴다.
 */
export const RefundCancelRow = ({ metric }: { metric: MetricWithObject }) => (
  <Wrapper>
    <Divider />
    <Row>
      <LeftGroup>
        <ColorBox color={REFUND_CANCEL_META.color} />
        <Label>{REFUND_CANCEL_META.label}</Label>
      </LeftGroup>
      <RightGroup>
        <Value>{formatRefundCancelWon(metric.revenue)}</Value>
        <SalesChangeIndicator
          neutral
          showIcon={false}
          changeRate={metric.changeRate}
        />
      </RightGroup>
    </Row>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #eaedf2;
  margin-bottom: 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
`;

const ColorBox = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  background: ${({ color }) => color};
  border-radius: 4px;
  margin-right: 6px;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #7b819a;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 380px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

const RightGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 0;
  flex-shrink: 1;
`;

const Value = styled.span`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  font-weight: 700;
  color: ${REFUND_CANCEL_META.color};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 380px) {
    font-size: 13px;
    line-height: 18px;
  }
`;
